import PropTypes from 'prop-types';
import React from 'react';

const ArrowCornerUpLeft = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4" />
  </svg>
);

ArrowCornerUpLeft.propTypes = {
  size: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
};

ArrowCornerUpLeft.defaultProps = {
  size: 12,
  style: {},
};

export default ArrowCornerUpLeft;
